// extracted by mini-css-extract-plugin
export const signupGroup = "login-module--signupGroup--LdslG";
export const inputEmail = "login-module--inputEmail--UbLzP";
export const inputPassword = "login-module--inputPassword--pnc+m";
export const txtForgetPassword = "login-module--txtForgetPassword--Tddy-";
export const btnLogin = "login-module--btnLogin--fZnje";
export const txtNoaccount = "login-module--txtNoaccount--KBBoN";
export const txtSignup = "login-module--txtSignup--ucoJQ";
export const errorMsg = "login-module--errorMsg--A1OEB";